import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const blogs = [
  {
    id: 'vpn-censorship',
    date: 'MAR 10, 2025',
    category: 'PRIVACY DEEP DIVES',
    title: 'What kinds of censorship can aSSL bypass?',
    summary: "We take a detailed look at how governments censor online services like TikTok and howSSLs...",
    content: `We take a detailed look at how governments censor online services like TikTok and howSSLs can help bypass these restrictions.\n\nIn this article, we explore the technical and legal aspects of internet censorship, the role ofSSLs, and real-world case studies.\n\nKey points:\n- HowSSLs work to bypass censorship\n- Limitations and risks\n- Countries with the strictest controls`,
    author: 'Jane Doe',
    image: '/public/vpn-sample.png',
  },
  {
    id: 'google-fingerprinting',
    date: 'MAR 4, 2025',
    category: 'PRIVACY DEEP DIVES',
    title: 'Google about-faces to allow device fingerprinting',
    summary: "In a spectacular about-face, Google has given the go-ahead to use unsafe and unfair ad tech tracki...",
    content: `In a spectacular about-face, Google has given the go-ahead to use unsafe and unfair ad tech tracking.\n\nWe break down what this means for user privacy, how device fingerprinting works, and what you can do to protect yourself.\n\nKey points:\n- What is device fingerprinting?\n- Why is Google allowing it?\n- How to protect your privacy`,
    author: 'John Smith',
    image: '/public/google-sample.png',
  },
  // {
  //   id: 'wetrackssl-censorship',
  //   date: 'FEB 6, 2025',
  //   category: 'PRIVACY DEEP DIVES',
  //   title: 'Behind the scenes ofwetracksslSSL’s fight against censorship',
  //   summary: "In 2024,wetracksslSSL provided freeSSL access leading up to elections in countries with a history...",
  //   content: `In 2024,wetracksslSSL provided freeSSL access leading up to elections in countries with a history of censorship.\n\nThis blog post details the technical and logistical challenges faced, and the impact on users.\n\nKey points:\n- HowwetracksslSSL enabled access\n- The impact on election integrity\n- Lessons learned`,
  //   author: 'Alex Lee',
  //   image: '/public/2024-sample.png',
  // },
];

const BlogPost: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = blogs.find((b) => b.id === id);

  if (!blog) {
    return (
      <div className="max-w-2xl mx-auto py-16 px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-2xl font-bold mb-4">Blog post not found</h1>
        <button onClick={() => navigate('/blog')} className="text-primary-600 underline">Back to Blog</button>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <button onClick={() => navigate('/blog')} className="text-primary-600 underline mb-6">← Back to Blog</button>
      <div className="bg-white rounded-2xl shadow-lg p-8">
        <div className="mb-4 text-xs text-gray-400 uppercase tracking-wide">{blog.date} · {blog.category}</div>
        <h1 className="text-3xl font-bold mb-2 text-purple-800">{blog.title}</h1>
        <div className="mb-6 text-sm text-gray-500">By {blog.author}</div>
        {/* Optionally add an image here if available */}
        <div className="prose max-w-none text-gray-800 whitespace-pre-line">{blog.content}</div>
      </div>
    </div>
  );
};

export default BlogPost;
